import { scale010, scale070, scale080, spaceL, spaceS } from '@xing-com/tokens';

import type {
  ContentSwitcherButtonIconSizeType,
  ContentSwitcherButtonFontSizeType,
} from './content-switcher-button';

export const BUTTON_BORDER_SIZE = scale010;
export const BUTTON_MARGIN_RIGHT: string = spaceS;
export const BUTTON_PADDING: string = spaceL;
export const CONTENT_SWITCHER_BUTTON_LIST_TEST_ID: string =
  'content-switcher-button-list-test-id';
export const FONT_FAMILY = `'XING Sans', 'Trebuchet MS', Arial, 'Helvetica Neue', sans-serif`;
export const FONT_SIZES: ContentSwitcherButtonFontSizeType = {
  small: scale070,
  medium: scale080,
};
export const FONT_WEIGHT = '700';
export const ICON_MARGIN_RIGHT: string = spaceS;
export const ICON_SIZES: ContentSwitcherButtonIconSizeType = {
  small: 18,
  medium: 24,
};
export const MINI_BADGE_MARGIN_RIGHT: string = spaceS;
